import React, { FC } from "react";
import { Login } from "./Login";
import { LoginAction } from "./LoginAction";


export const LoginProfilePage: FC = () => {
  return <Login action={LoginAction.Profile} />;
};
